import(/* webpackMode: "eager" */ "/vercel/path0/src/components/pages/PagesComponent.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/seo/RankMathSchema.tsx")